import { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export function useDimensionsRef() {
    const [height, setHeight] = useState(0);
    const [width, setWidth] = useState(0);
    const ref = useRef(null);
    useEffect(() => {
        const currentRef = ref.current;
        function handleObservableResizeEvent(nodeList) {
            const _height = nodeList[0]?.contentRect.height || height;
            const _width = nodeList[0]?.contentRect.width || width;
            if (_height !== height)
                setHeight(_height);
            if (_width !== width)
                setWidth(_width);
        }
        const resizeObserver = new ResizeObserver(handleObservableResizeEvent);
        if (currentRef)
            resizeObserver.observe(currentRef);
        return () => {
            if (currentRef)
                resizeObserver.unobserve(currentRef);
        };
    }, []); // eslint-disable-line
    return [ref, { height, width }];
}
//# sourceMappingURL=useDimensionsRef.js.map